export const TestIds = {
  title: 'title',
  description: 'description',
  okButton: 'ok-button',
  secondaryButton: 'secondary-button',
} as const;
